import { WarrantyFormModal } from '@retainerclub/common';
import PropTypes from 'prop-types';
import { useState } from 'react';
import DashboardNoRecord from '../DashboardNoRecord/DashboardNoRecord';
import DashboardShipmentsTableRow from './DashboardShipmentsTableRow';
import ManageShipmentModal from './ManageShipmentModal/ManageShipmentModal';

function DashboardShipmentsTable({ shipments, refetch }) {
  const [activeShipment, setActiveShipment] = useState(null);
  const [open, setOpen] = useState(false);
  const [warrantyModalOpen, setWarrantyModalOpen] = useState(false);
  const [warrantyShipment, setWarrantyShipment] = useState(null);

  function handleOpenModal(p) {
    setActiveShipment(p);
    setOpen(true);
  }

  function handleCloseModal() {
    setOpen(false);
    setActiveShipment(null);

    refetch();
  }

  function handleWarrantyModalOpen(shipment) {
    setWarrantyShipment(shipment);
    setWarrantyModalOpen(true);
  }

  function handleWarrantyModalClose() {
    setWarrantyModalOpen(false);
    setWarrantyShipment(null);
    refetch();
  }

  return (
    <>
      <div className="mt-4 rounded-lg border border-rcgray-200 bg-rcgray-50/50 p-4 shadow-md">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pr-3 pl-4 text-left font-semibold text-gray-900 text-sm sm:pl-0"
              >
                Details
              </th>
              <th
                scope="col"
                className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm lg:table-cell"
              >
                Who&apos;s it for?
              </th>
              <th
                scope="col"
                className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
              >
                Where&apos;s it going?
              </th>
              <th
                scope="col"
                className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
              >
                Shipping info
              </th>
              <th scope="col" className="py-3.5 pr-4 pl-3 sm:pr-0">
                <span className="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {shipments.length > 0 ? (
              shipments.map((shipment) => (
                <DashboardShipmentsTableRow
                  key={shipment.id}
                  shipment={shipment}
                  handleOpenModal={handleOpenModal}
                  handleWarrantyModalOpen={handleWarrantyModalOpen}
                />
              ))
            ) : (
              <tr>
                <td colSpan={5} className="py-4">
                  <DashboardNoRecord text="Sorry, you don't have any upcoming shipments waiting for you." />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ManageShipmentModal
        open={open}
        handleCloseModal={handleCloseModal}
        activeShipment={activeShipment}
        refetch={refetch}
      />
      {warrantyModalOpen && warrantyShipment && (
        <WarrantyFormModal
          isOpen={warrantyModalOpen}
          onClose={handleWarrantyModalClose}
          productionOrderId={warrantyShipment.id}
          refetch={refetch}
        />
      )}
    </>
  );
}

DashboardShipmentsTable.propTypes = {
  shipments: PropTypes.array.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default DashboardShipmentsTable;
